module.exports = __webpack_public_path__ + "media/soundtrack.e3723243.mp3";